import React from 'react';
import { Head } from '@ecommerce/nest-ssr/components';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { SortType } from '../../../../reducers/offers';
import { offersSort } from 'helpers/offers-sort';
import { ProductInterface } from 'modules/product/interfaces/product.interface';
import { CategoryFull } from 'modules/shared/modules/categories-shared/interfaces/category-full.interface';
import offersPrepare from 'helpers/offers-prepare';

const MetaTagsProduct: React.FC<{
    productId: ProductInterface['id'];
    producerName: ProductInterface['name'];
    offersCount: number;
    categoryName: CategoryFull['name'];
    categoryDepartmentName: string;
    categorySubDepartmentName: string;
    seoRobotsContent?: string;
}> = ({
    productId,
    producerName,
    offersCount,
    categoryName,
    categoryDepartmentName,
    categorySubDepartmentName,
    seoRobotsContent
}) => {
    const offersFinal = useSelector((state: { product: ProductInterface; }) => (
        [...offersPrepare(state.product.offers.items)]
    )).sort(offersSort(SortType.PriceAsc));
    const price = offersCount === 0 ? 0 : offersFinal[0]?.price;

    return (
        <Head>
            <meta property="product:availability" content={offersCount === 0 ? 'oos' : 'instock'} />
            <meta property="product:brand" content={producerName} />
            <meta
                property="product:category"
                content={`${categoryName} > ${categorySubDepartmentName} > ${categoryDepartmentName}`}
            />
            <meta property="product:price:amount" content={String(price)} />
            <meta property="product:price:currency" content="PLN" />
            <meta property="product:retailer_item_id" content={String(productId)} />
            <meta name="robots" content={seoRobotsContent} />
        </Head>
    );
};

export default MetaTagsProduct;
